export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_15.7db815b4.jpg";